<template>
  <div style="height: 100%; display: flex; flex-flow: column">
    <el-row class="mb-1" :gutter="5" v-if="!UseBySelect">
      <el-col>
        <el-button type="info" plain @click="AddPart"><i class="iconfont icon-add-new"></i>&nbsp;&nbsp;添加部件
        </el-button>
        <el-button type="info" plain class="ml-2" @click="AddItem"><i class="iconfont icon-add-new"></i>&nbsp;&nbsp;添加物料
        </el-button>
        <el-button type="info" plain class="ml-2" @click="AddAccessory"><i
            class="iconfont icon-add-new"></i>&nbsp;&nbsp;添加附件
        </el-button>
        <el-tag class="ml-2" v-if="copy_row">{{
          `当前复制数据: 部件名称: ${copy_row.PartName}, 物料类型: ${copy_row.ItemTypeName} `
          }}</el-tag>
      </el-col>
    </el-row>
    <el-row class="mb-1" :gutter="5" v-if="UnSelectData.length > 0">
      <el-col>
        <el-tag class="ml-2" effect="dark" type="danger"><i class="el-icon-star-on"></i>{{
          `红色行为工艺检查不包含数据`
          }}</el-tag>
      </el-col>
    </el-row>
    <div style="flex: 1; height: 0" ref="tree_table_div_ref">
      <el-table size="mini" :data="tableData" row-key="id" border default-expand-all ref="tempQuotationItemTableRef"
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }" @row-click="RowClick"
        :max-height="maxTableHeight" :row-class-name="tableRowClassName" highlight-current-row
        class="tree-table-class w-100">
        <el-table-column prop="PartName" label="部件名称" sortable width="350">
          <template slot-scope="scope">
            <span style="margin-left: 10px" v-if="!scope.row.isEdit">{{
              scope.row.PartName
              }}</span>
            <div v-else>
              <el-input v-model="scope.row.PartName"></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="ItemTypeName" label="物料类型" sortable width="100">
        </el-table-column>
        <el-table-column prop="ItemName" label="物料名称" width="180">
        </el-table-column>
        <el-table-column prop="Spec" label="规格" width="200">
        </el-table-column>
        <el-table-column prop="TEC_GoLength" label="上机长mm">
          <template slot-scope="scope">
            <span>{{ GetTableNullDataShow(scope.row, 'TEC_GoLength') }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="TEC_GoWidth" label="上机宽mm">
          <template slot-scope="scope">
            <span>{{ GetTableNullDataShow(scope.row, 'TEC_GoWidth') }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="Mould_Count" label="排版模数">
          <template slot-scope="scope">
            <span>{{ GetTableNullDataShow(scope.row, 'Mould_Count') }}</span>
          </template></el-table-column>
        <el-table-column prop="UseLength" label="用料长mm"><template slot-scope="scope">
            <span>{{ GetTableNullDataShow(scope.row, 'UseLength') }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="UseWidth" label="用料宽mm">
          <template slot-scope="scope">
            <span>{{ GetTableNullDataShow(scope.row, 'UseWidth') }}</span>
          </template></el-table-column>
        <el-table-column prop="Cut_Count" label="开数">
          <template slot-scope="scope">
            <span>{{ GetTableNullDataShow(scope.row, 'Cut_Count') }}</span>
          </template></el-table-column>
        <el-table-column prop="MatchA" label="配比数A" width="100">
          <template slot-scope="scope">
            <span style="margin-left: 10px" v-if="!scope.row.isEdit">{{
              scope.row.MatchA
              }}</span>
            <div v-else>
              <el-input-number type="number" v-model.number="scope.row.MatchA" @input="calcTotalQty(scope.row)"
                style="width: 100%;" :controls="false"></el-input-number>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="MatchA" label="配比数B" width="100">
          <template slot-scope="scope">
            <span style="margin-left: 10px" v-if="!scope.row.isEdit">{{
              scope.row.MatchB
              }}</span>
            <div v-else>
              <el-input-number type="number" v-model.number="scope.row.MatchB" @input="calcTotalQty(scope.row)"
                style="width: 100%;" :controls="false"></el-input-number>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="Unit_Count" label="部件用量" width="100">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{
              scope.row.Unit_Count
              }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="Unit_Use" label="部件用量单位" width="100">
        </el-table-column>
        <el-table-column prop="Total_Qty" label="总用量（正数）" width="180">
          <template slot-scope="scope">
            <span style="margin-left: 10px" v-if="!scope.row.isEdit">{{
              scope.row.Total_Qty
              }}</span>
            <div v-else>
              <el-input-number type="number" v-model.number="scope.row.Total_Qty" :controls="false"></el-input-number>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="Description" label="备注" width="200">
          <template slot-scope="scope">
            <span style="margin-left: 10px" v-if="!scope.row.isEdit">{{
              scope.row.Description
              }}</span>
            <div v-else>
              <el-input type="text" placeholder="请输入内容" v-model="scope.row.Description" maxlength="500"
                show-word-limit></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="180">
          <template slot-scope="scope" v-if="scope.row.ItemTypeName">
            <el-button type="text" size="small" @click="changeRowState(scope.row)" v-if="!UseBySelect"
              :disabled="scope.row.isDisabled">{{
                scope.row.isEdit ? '保存' : '编辑'
              }}</el-button>
            <el-button type="text" size="small" @click="CopyRow(scope.row)" v-if="!UseBySelect">复制</el-button>
            <el-button type="text" size="small" @click="PasteRow(scope.row)" v-if="!UseBySelect">粘贴</el-button>
            <el-button type="text" size="small" @click="DeleteRow(scope.row)" v-if="!UseBySelect">删除</el-button>
            <!-- {{ `scope.row.ParentId: ${scope.row.ParentId}, currentQuotationDetailId: ${currentQuotationDetailId}` }} -->
            <el-button type="text" size="small" v-if="UseBySelect && UnSelectData.length === 0"
              :disabled="scope.row.ParentId != currentQuotationDetailId"
              @click="SelectRowToProcess(scope.row)">选择</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <BaseModal :mask="false" ref="partModal" :title="add_part_title" @saveData="SaveData" :width="'30%'">
      <template #modal_content>
        <el-form :rules="rules" :model="partModel" ref="dataForm" label-width="100px" class="demo-dataForm">
          <el-form-item label="部件名称" prop="PartName">
            <el-input clearable v-model="partModel.PartName" placeholder="请输入部件名称"></el-input>
          </el-form-item>
          <el-form-item label="配比数A" prop="MatchA">
            <el-input-number class="w-100" clearable v-model.number="partModel.MatchA" placeholder="请输入配比数"
              type="number" :controls="false"></el-input-number>
          </el-form-item>
          <el-form-item label="配比数B" prop="MatchB">
            <el-input-number class="w-100" clearable v-model.number="partModel.MatchB" placeholder="请输入配比数"
              type="number" :controls="false"></el-input-number>
          </el-form-item>
          <!-- <el-form-item label="单位用量" prop="Unit_Count">
            <el-input-number class="w-100" clearable v-model.number="partModel.Unit_Count" placeholder="请输入单位用量"
              type="number" :controls="false"></el-input-number>
          </el-form-item> -->
          <el-form-item label="计量单位" prop="Unit_Use">
            <el-select placeholder="请选择计量单位" size="small" v-model="partModel.Unit_Use" filterable clearable
              class="w-100">
              <el-option v-for="item in $store.state.biz_data.baseData.UnitOfMeasure" :key="item.Symbol"
                :label="item.Symbol" :value="item.Symbol"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注" prop="Derscription">
            <el-input type="textarea" clearable v-model="partModel.Description" maxlength="500"
              show-word-limit></el-input>
          </el-form-item>
        </el-form>
      </template>
    </BaseModal>
    <el-drawer :title="'添加物料'" :visible.sync="drawer" :with-header="true" :size="'70%'" @opened="DrawerOpend"
      style="height: calc(100vh)" :modal="false">
      <template slot="title">
        <span>添加物料</span>
      </template>
      <TempQuotationItem ref="TempQuotationTable" :showSelectButton="true" :table_height="tableHeight"
        @EmitTempQuotationItem="EmitTempQuotationItem"></TempQuotationItem>
    </el-drawer>
    <el-dialog :title="dialog_title" :visible.sync="accessoryVisible" width="60%" :top="'5vh'"
      :close-on-click-modal="false" :modal="false" @opened="bottomDialogOpened">
      <FileUpload ref="refAccessory" :accessoryCategory="'TempQuotation'" :showUpload="true"
        @setAccessory="bottomSetAccessory">
      </FileUpload>
    </el-dialog>
  </div>
</template>
<script>
import BaseModal from '../components/modals/baseModal'
import * as TempQuotationCreateItemController from '../../controllers/sd/TempQuotationCreateItemController'
import * as TempQuotationItemController from '../../controllers/sd/TempQuotationItemController'
import * as TempQuotationController from '../../controllers/sd/TempQuotationController'
import TempQuotationItem from './TempQuotationItem.vue'
import FileUpload from '../FileUpload.vue'
export default {
  components: { BaseModal, TempQuotationItem, FileUpload },
  props: {
    SelectItemData: { type: Object, default: null },
    UseBySelect: { type: Boolean, default: false },
    UnSelectData: { type: Array, default: () => [] },
    currentQuotationDetailId: { type: Number, default: null }
  },
  data() {
    return {
      tree_index: 0,
      accessoryVisible: false,
      dialog_title: '附件列表',
      maxTableHeight: 250,
      quotation_item_fields: TempQuotationItemController.fields.default,
      tableHeight: 200,
      drawer: false,
      current_item: null,
      partModel: {
        id: '', //id
        tempItemNum: '', //物料编号
        ParentId: 0, //父id
        PartName: '', //部件名称
        MatchA: 1,//配比数A
        MatchB: 1,//配比数B
        Unit_Count: 0, //单位用量
        Unit_Use: '', //计量单位
        Description: '', //备注
      },
      tableData: [],
      fields: [],
      table_title: '临时物料',
      add_part_title: '',
      rules: TempQuotationCreateItemController.rules,
      date_picker_label: 'common.search',
      query_lable: this.$t('common.query'),
      isBusy: false,
      copy_row: null,
      copy_state: true,
      all_table_data: [],
    }
  },
  async created() { },
  async mounted() {
    this.tableHeight = '75vh'
    this.$nextTick(() => {
      this.maxTableHeight =
        this.$refs.tree_table_div_ref.offsetHeight - 50
    })
    //查询数据并构造数据
    await this.QueryDataAndConstruction(this.SelectItemData.id)
  },
  methods: {
    //进制法计算
    binaryCalac(num, itemType) {
      if (!itemType)
        return num
      let type = _.find(this.$store.state.biz_data.baseData.ItemType, { id: itemType })
      if (type) {
        if (type.BinaryType === 0) {
          //无进制法
          return num
        }
        else if (type.BinaryType === 1) {
          //四舍五入(保留6位小数)
          return _.round(num, 12)
        }
        else {
          //进一法
          return Math.ceil(num)
        }
      }
      else
        return num
    },
    SetDisabled(row, data, state) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].id != row.id)
          this.$set(data[i], 'isDisabled', state)
        if (data[i].children instanceof Array && data[i].children.length > 0) {
          this.SetDisabled(row, data[i].children, state)
        }
      }
    },
    SelectRowToProcess(row) {
      this.$emit('SelectRowToProcess', row)
    },
    //添加附件
    AddAccessory() {
      this.accessoryVisible = true
    },
    //展示空数据方法
    GetTableNullDataShow(row, key) {
      if (row[key] && row.ItemTypeId) {
        return row[key]
      } else if (!row.ItemTypeId) {
        return ''
      } else return '/'
    },
    //物料输入单位用量后计算计算总用量
    calcTotalQty(row) {
      //获取父级上的总用量
      let parent = _.find(this.all_table_data, { id: row.ParentId })
      row.Unit_Count = _.round((row.MatchB / row.MatchA), 12)
      if (parent.Total_Qty) {
        if (row.Cut_Count && row.Mould_Count) {
          //有模数和开数,则加入二者进行运算
          row.Total_Qty = this.binaryCalac(
            (parent.Total_Qty / row.Cut_Count / row.Mould_Count) *
            row.Unit_Count, row.ItemTypeId)
        } else {
          row.Total_Qty = this.binaryCalac(parent.Total_Qty * row.Unit_Count, row.ItemTypeId)
        }
      }
      //如果有子级,需要修改子级中的数量
      if (row.children instanceof Array && row.children.length > 0) {
        for (var i = 0; i < row.children.length; i++) {
          this.calcTotalQty(row.children[i])
        }
      }
    },
    //粘贴
    PasteRow(row) {
      const _this = this
      //数据验证
      if (!this.copy_row) {
        return
      }
      //判断是否为末端
      if (row.ItemTypeId) {
        this.msgToasts('该行为末端无法粘贴数据集!', 'warning')
        return
      }
      //检查粘贴行中是否存在相同的物料
      if (row.children instanceof Array && row.children.length > 0) {
        if (_.findIndex(row.children, function (o) {
          return o.ItemId == _this.copy_row.ItemId && _this.copy_row.ItemId != null
        }) > -1) {
          this.msgToasts('该级下已含有相同的物料!', 'warning')
          return
        }
      }
      //粘贴确认
      this.$confirm('是否复制该行数据及其包含的数据集？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          await _this.GetCopyData([this.copy_row], row.id, row.Total_Qty)
          await this.QueryDataAndConstruction(this.SelectItemData.id)
          if (_this.copy_state) {
            _this.msgToasts(this.$t('notify.action_successfully'), 'success')
            _this.copy_state = true
          }
        })
        .catch(() => { })
    },
    //递归获取复制数据
    async GetCopyData(data, id, total_qty) {
      const _this = this
      for (var i = 0; i < data.length; i++) {
        let p = {}
        let add_data = []
        let _copy = _.cloneDeep(data[i])
        delete _copy.children
        delete _copy.isEdit
        delete _copy.id
        delete _copy.isDisabled
        _copy.ParentId = id
        if (_copy.Cut_Count && _copy.Mould_Count) {
          //有模数和开数,则加入二者进行运算
          _copy.Total_Qty =
            (total_qty / _copy.Cut_Count / _copy.Mould_Count) *
            _copy.Unit_Count
        } else {
          _copy.Total_Qty = total_qty * _copy.Unit_Count
        }
        add_data.push(_copy)
        p.add = add_data
        let rt = await TempQuotationCreateItemController.methods.saveData(p)
        if (rt) {
          if (data[i].children instanceof Array && data[i].children.length > 0)
            await _this.GetCopyData(
              data[i].children,
              rt[0].id,
              rt[0].Total_Qty
            )
        } else {
          _this.copy_state = false
          _this.msgToasts(_this.$t('notify.action_unsuccessfully'), 'error')
        }
      }
    },
    //复制
    CopyRow(row) {
      this.copy_row = row
    },
    //递归获取删除数据
    GetDeleteData(data, arr) {
      for (var i = 0; i < data.length; i++) {
        arr.push(data[i])
        if (data[i].children instanceof Array && data[i].children.length > 0) {
          this.GetDeleteData(data[i].children, arr)
        }
      }
    },
    //删除数据
    DeleteRow(row) {
      const _this = this
      //删除确认
      this.$confirm('是否删除该行数据及其包含的数据集？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          let p = {}
          let delete_data = []
          delete_data.push(row)
          if (row.children instanceof Array && row.children.length > 0) {
            _this.GetDeleteData(row.children, delete_data)
          }
          p.delete = delete_data
          let rt = await TempQuotationCreateItemController.methods.saveData(p)
          if (rt) {
            await this.QueryDataAndConstruction(this.SelectItemData.id)
            this.msgToasts(this.$t('notify.action_successfully'), 'success')
          } else {
            this.msgToasts(this.$t('notify.action_unsuccessfully'), 'error')
          }
        })
        .catch(() => {
          return
        })
    },
    GetEditData(row, edit_data) {
      let p = _.cloneDeep(row)
      delete p.isEdit
      delete p.isCopy
      delete p.children
      delete p.isDisabled
      edit_data.push(p)
      if (row.children instanceof Array && row.children.length > 0) {
        for (var i = 0; i < row.children.length; i++) {
          this.GetEditData(row.children[i], edit_data)
        }
      }
    },
    //修改保存时的数据检查
    CheckEditData(data) {
      if (
        _.findIndex(data, function (o) {
          return !o.PartName
        }) > -1
      ) {
        this.msgToasts('修改失败,部件名称不能为空', 'error')
        return false
      }
      if (
        _.findIndex(data, function (o) {
          return !o.Unit_Count || o.Unit_Count < 0
        }) > -1
      ) {
        this.msgToasts('修改失败,单位用量错误', 'error')
        return false
      }
      if (
        _.findIndex(data, function (o) {
          return !o.Total_Qty || o.Total_Qty < 0
        }) > -1
      ) {
        this.msgToasts('修改失败,总用量错误', 'error')
        return false
      }
      return true
    },
    //改变修改状态并实际修改数据
    async changeRowState(row) {
      if (row.isEdit) {
        let edit_data = []
        this.GetEditData(row, edit_data)
        //数据检查
        if (!this.CheckEditData(edit_data)) return
        let rt = await TempQuotationCreateItemController.methods.saveData({
          edit: edit_data,
        })
        if (rt) {
          this.msgToasts('修改成功', 'success')
          await this.QueryDataAndConstruction(this.SelectItemData.id, row)
          setTimeout(() => {
            this.reSetCurrentRow(row, this.tableData)
          }, 1000);
        } else {
          this.msgToasts('修改失败', 'error')
        }
        this.SetDisabled(row, this.tableData, false)
      }

      this.$set(row, 'isEdit', !row.isEdit)
      if (row.isEdit) {
        //将出本行外所有行的 isDisabled 置为true
        this.$set(row, 'isDisabled', false)
        this.SetDisabled(row, this.tableData, row.isEdit)
      }

    },
    reSetCurrentRow(row, data) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].id == row.id) {
          console.log(data[i])
          this.$refs.tempQuotationItemTableRef.setCurrentRow(data[i]);
        }
        else
          if (data[i].children instanceof Array && data[i].children.length > 0) {
            this.reSetCurrentRow(row, data[i].children)
          }
      }
    },
    //emit事件添加物料
    async EmitTempQuotationItem(items, matchA, matchB) {
      //检查该级下是否已含有相同的物料
      let bool = true
      for (var i = 0; i < items.length; i++) {
        let item = items[i]
        if (_.findIndex(this.current_item.children, { ItemId: items[i].id }) > -1) {
          this.msgToasts('该级下已含有相同的物料!', 'warning')
          return
        }
        let p = {}
        p.id = ''
        p.ParentId = this.current_item.id //父id
        p.QuotationId = this.SelectItemData.id //主档id
        p.ItemTypeName = item.ItemTypeName
        p.ItemTypeId = item.ItemTypeId
        p.ItemName = item.ItemName
        p.PartName = item.ItemName
        p.ItemId = item.id
        p.Spec = item.Spec
        p.TEC_GoLength = item.TEC_GoLength
        p.TEC_GoWidth = item.TEC_GoWidth
        p.Mould_Count = item.Mould_Count
        p.UseLength = item.UseLength
        p.UseWidth = item.UseWidth
        p.Cut_Count = item.Cut_Count
        p.MatchA = matchA
        p.MatchB = matchB
        p.Unit_Count = _.round((matchB / matchA), 12)//单位用量 保留小数点6位
        if (item.Cut_Count && item.Mould_Count) {
          //有模数和开数,则加入二者进行运算 加入物料类型中的进制法
          p.Total_Qty = this.binaryCalac((this.current_item.Total_Qty / item.Cut_Count / item.Mould_Count) *
            p.Unit_Count, p.ItemTypeId)

        } else {
          p.Total_Qty = this.binaryCalac(this.current_item.Total_Qty * p.Unit_Count, p.ItemTypeId)
        }
        p.Unit_Use = item.Unit_Use
        let rt = await TempQuotationCreateItemController.methods.saveData({
          add: p,
        })
        if (rt) {
          //给table中添加一行数据
          if (this.current_item.children instanceof Array) {
            this.current_item.children.push(rt[0])
          } else {
            this.$set(this.current_item, 'children', [rt[0]])
          }
        } else {
          bool = false
          return
        }
      }
      if (!bool)
        this.msgToasts('新增失败', 'error')
      else
        this.msgToasts('新增成功', 'success')
    },
    //构造第一行数据
    AddFirstLineData() {
      this.tableData = []
      this.tableData.push({
        id: -1,
        PartName: this.SelectItemData.tempItemName
          ? this.SelectItemData.tempItemName
          : this.SelectItemData.ItemName,
        Total_Qty: this.SelectItemData.quotationQty,
      })
    },

    //查询并构造树形数据
    async QueryDataAndConstruction(quotationId) {
      this.tree_index = 0
      this.AddFirstLineData()
      let p = { is_deleted: { '=': 0 }, QuotationId: { '=': quotationId } }
      let _result = await TempQuotationCreateItemController.methods.getData(p)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        //数据构造
        _result[0].forEach(o => {
          if (o.ParentId == 0) {
            o.ParentId = -1
          }
        });
        this.all_table_data = _result[0]
        this.all_table_data.push(this.tableData[0])

        this.makeTableData(_result[0], this.tableData)
      }
    },
    //树状数据构造
    makeTableData(all_data, data) {
      for (let i = 0; i < data.length; i++) {
        let children = _.filter(all_data, { ParentId: data[i].id })
        if (children) {
          this.$set(data[i], 'children', children)
          this.makeTableData(all_data, data[i].children)
        }
      }
    },
    // 行点击事件
    RowClick(row) {
      this.current_item = row
    },
    //清除model
    clearModel() {
      this.partModel = {
        id: '', //id
        ItemNum: '', //物料编号
        ParentId: 0, //父id
        PartName: '', //部件名称
        MatchA: 1,
        MatchB: 1,
        Unit_Count: 0, //单位用量
        Unit_Use: '', //计量单位
        Total_Qty: '', //总用量
        Description: '',
        ItemTypeName: '部件',
      }
    },
    //添加物料
    AddItem() {
      //检查数据是否为部件,如果不是,则无法添加物料
      if (!this.current_item) {
        this.msgToasts('请先选择要添加的数据行!', 'warning')
        return
      }
      if (
        this.current_item.ItemTypeName && this.current_item.ItemTypeName != '部件' &&
        this.current_item.id != 0
      ) {
        this.msgToasts('该行无法继续添加下一级!', 'warning')
        return
      }

      this.drawer = true
    },
    //添加部件
    AddPart() {
      //检查
      if (!this.current_item) {
        this.msgToasts('请先选择要添加的数据行!', 'warning')
        return
      }
      console.log(this.current_item)
      if (
        this.current_item.ItemTypeName && this.current_item.ItemTypeName != '部件' &&
        this.current_item.id != 0
      ) {
        this.msgToasts('该行无法继续添加下一级!', 'warning')
        return
      }
      this.clearModel()
      this.SelectItemData.ItemNum = this.SelectItemData.tempItemNum
        ? this.SelectItemData.tempItemNum
        : this.SelectItemData.ItemId //判断是临时物料或者正式物料
      if (this.tableData.length === 1) {
        this.add_part_title = `部件名称:${this.current_item.PartName}  报价数量:${this.current_item.Total_Qty}`
        // this.partModel.Total_Qty = this.current_item.Unit_Count;
        this.$refs.partModal.show()
      }
    },
    //部件保存
    async addPartData(cb) {
      let p = {}
      p.id = this.partModel.id //id
      p.ParentId = this.current_item.id //父id
      p.QuotationId = this.SelectItemData.id //主档id
      p.PartName = this.partModel.PartName //部件名称
      p.MatchA = this.partModel.MatchA //配比数A
      p.MatchB = this.partModel.MatchB //配比数B
      p.Unit_Count = _.round((this.partModel.MatchB / this.partModel.MatchA), 12) //单用用量 配比数B/配比数A 保留6位小数
      p.Description = this.partModel.Description //备注
      p.Unit_Use = this.partModel.Unit_Use //计量单位
      p.ItemTypeName = this.partModel.ItemTypeName //部件
      p.Total_Qty = p.Unit_Count * this.current_item.Total_Qty //本级总用量=上级总用量*本级的单位用量(默认值后续可以修改)
      let rt = await TempQuotationCreateItemController.methods.saveData({
        add: p,
      })
      if (rt) {
        //给table中添加一行数据
        if (this.current_item.children instanceof Array) {
          this.current_item.children.push(rt[0])
          this.all_table_data.push(rt[0])
        } else {
          this.$set(this.current_item, 'children', [rt[0]])
        }
        cb(true, true)
      } else {
        cb(false)
      }
    },
    //给树形table添加数据
    insertTableData(list, data) {
      let res = list.find((item) => item.id === data.ParentId)
      if (res) {
        if (res.children instanceof Array) {
          res.children.push(data)
        } else {
          this.$set(res, 'children', [data])
        }
        return
      } else {
        for (let i = 0; i < list.length; i++) {
          if (list[i].children instanceof Array) {
            this.insertTableData(list[i].children, data)
          }
        }
      }
    },
    async SaveData(cb) {
      this.$refs.dataForm.validate(async (valid) => {
        if (valid) {
          //新增或保存过程
          if (this.partModel.id === '') await this.addPartData(cb)
        } else {
          cb(true, false, '')
          return
        }
      })
    },
    async DrawerOpend() {
      //
    },
    //附件open
    bottomDialogOpened() {
      let _accessory = this.SelectItemData.Accessory
      this.$refs.refAccessory.getAccessory(_accessory, this.SelectItemData.id)
    },
    async bottomSetAccessory(data) {
      this.SelectItemData.Accessory = data
      await this.dialogClosed()
    },
    async dialogClosed() {
      if (this.SelectItemData && this.SelectItemData.Accessory) {
        let m = {
          id: this.SelectItemData.id,
          Accessory: this.SelectItemData.Accessory,
        },
          ml = []
        if (m.id && m.id != '') ml.push(m)
        this.SelectItemData.AccessoryCount = JSON.parse(
          this.SelectItemData.Accessory
        ).length
        await TempQuotationController.methods.updateAccessory({ edit: ml })
      }
    },
    //行样式修改
    tableRowClassName({ row }) {
      if (!row.ItemTypeId) {
        return 'bujian-row'
      } else if (
        _.findIndex(this.UnSelectData, { id: row.id }) > -1
      ) {
        return 'error-row'
      } else return ''
    },
  },
}
</script>
<style>
.hb_table_quotationorder_class1 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 195rem;
}

.el-table .bujian-row {
  background: #e1f3d8;
}

.el-table .error-row {
  background: #F56C6C;
}

.tree-table-class .el-table__row {
  height: 30px;
  padding: 0;
}

.tree-table-class .el-table__cell {
  white-space: normal;
  padding: 0;
}

.tree-table-class .el-table__body tr.current-row>td {
  background-color: #67C23A !important;
  color: #fff;
}
</style>
